import React from "react";

import { Table } from "widgets";
import { CASH_PAYMENT_METHOD, INR_SYMBOL, PAYMENT_STATUSES } from "constants/config";

import styles from "./PaymentDetails.module.scss";

const paymentDetailsColumn = [
  { label: "Amount", field: "amount" },
  { label: "Status", field: "status" },
  { label: "Payment Date", field: "paymentDate" },
  { label: "Payment Method", field: "paymentMethod" },
];

const getPaymentStatusName = (status, methodId) => {
  if (status.id === PAYMENT_STATUSES.DISBURSED && methodId === CASH_PAYMENT_METHOD) {
      return "ACKNOWLEDGED";
    }
    return status.name;
  }

const getPaymentDetailsRows = (paymentDetails = []) => {
  return paymentDetails
    .sort((p1, p2) => new Date(p2.date) - new Date(p1.date))
    .map((payment) => ({
      amount: INR_SYMBOL + payment.amount,
      status: getPaymentStatusName(payment.status, payment.method?.id),
      paymentDate: new Date(payment.date).toLocaleString(),
      paymentMethod: payment.method?.name,
    }));
};

const PaymentDetails = (props) => {
  const { paymentDetails } = props;
  const rows = paymentDetails ? getPaymentDetailsRows(paymentDetails) : [];

  return (
    <div className={styles.paymentDetailsTable}>
      <Table columns={paymentDetailsColumn} rows={rows} />
    </div>
  );
};

export default PaymentDetails;
